// A signed-in app visit through a campaign's tap URL is an "opened" receipt,
// not proof that Android displayed the notification before the tap.
export function startPushOpenTracking() {
    if (!/(?:^|\s)(?:NamiGamesAndroid|RickEliteSpinsAndroid|HittingSlotsAndroid|LuckyVaultAndroid)\//.test(navigator.userAgent)) return () => {};
    let busy = false, stopped = false, completed = "", controller = null;
    const tick = async () => {
        if (stopped || busy || document.visibilityState !== "visible") return;
        const id = new URLSearchParams(window.location.search).get("push_notice");
        if (!id || !/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(id)) return;
        let token;
        try { token = localStorage.getItem("clubsClientToken"); } catch { return; }
        if (!token || completed === `${id}:${token}`) return;
        busy = true;
        controller = new AbortController();
        const timeout = setTimeout(() => controller?.abort(), 5000);
        try {
            const response = await fetch(`/api/notifications/native/opened/${id}`, { method: "POST", headers: { Authorization: `Bearer ${token}` }, cache: "no-store", credentials: "omit", signal: controller.signal });
            if (response.ok) completed = `${id}:${token}`;
        } catch { /* retry next foreground tick without interrupting the app */ }
        finally { clearTimeout(timeout); busy = false; }
    };
    tick();
    const interval = setInterval(tick, 30000);
    window.addEventListener("focus", tick);
    document.addEventListener("visibilitychange", tick);
    return () => { stopped = true; controller?.abort(); clearInterval(interval); window.removeEventListener("focus", tick); document.removeEventListener("visibilitychange", tick); };
}
